import { useEffect, useState } from "react";
import BranchService from "../../services/resource/branchService";
import { useFormik } from "formik";
import DropDown from "../../components/dropdown/dropdown";
import ButtonLoading from "../../components/buttonLoading/buttonLoading";
import { toast } from 'react-toastify';
import { useAuth } from "../../context/authContext";
import DriverAssistantService from "../../services/resource/driverAssistant";
import DriverAssistantCreate from "./DriverAssistantCreate";
import DriverAssistantUpdate from "./DriverAssistantUpdate";

const initialValues = {
    id: '',
    name: '',
    branchName: '',
    branchId: null,
}

function DriverAssistantList() {
    const driverAssistantService = new DriverAssistantService();
    const branchService = new BranchService();

    const { user } = useAuth();
    const [count, setCount] = useState(0);
    const [driverAssistants, setDriverAssistants] = useState([]);
    const [selectedDriverAssistant, setSelectedDriverAssistant] = useState(initialValues);
    const [page, setPage] = useState(0);
    const [totalElements, setTotalElements] = useState(0);
    const [pageSize] = useState(20);
    const [branches, setBranches] = useState([]);
    const [loading, setLoading] = useState(false);
    const [showModalCreate, setShowModalCreate] = useState(false);
    const [showModalUpdate, setShowModalUpdate] = useState(false);
    const [showModalDelete, setShowModalDelete] = useState(false);
    const formik = useFormik({
        initialValues: initialValues
    });

    useEffect(() => {
        if (count > 0) {
            loadDriverAssistants();
        }
    }, [page]);

    useEffect(() => {
        branchService.findAll().then(response => {
            setBranches(response.data)
        });

        formik.setFieldValue("branchId", user.branchid);

        loadDriverAssistants({ ...formik.values, branchId: user.branchid });

        setCount(1);
    }, []);



    const loadDriverAssistants = (values = formik.values) => {
        setLoading(true);

        driverAssistantService.findAll(values, pageSize, page).then(response => {
            setDriverAssistants(response.data.content);
            setTotalElements(response.data.totalElements);
        }).catch(error => {
            console.error('Erro ao carregar ajudantes', error);
        }).finally(() => {
            setTimeout(() => setLoading(false), 400);
        })
    };

    const handleSubmitDriverAssistants = (event) => {
        event.preventDefault();
        loadDriverAssistants();
    }

    const handlePrevPage = () => {
        if (page > 0) setPage(page - 1);
    };

    const handleNextPage = () => {
        if ((page + 1) * pageSize < totalElements) setPage(page + 1);
    };

    const selectedDriverAssistantUpdate = (driverAssistant) => {
        setSelectedDriverAssistant(driverAssistant);
        setShowModalUpdate(true)
    }

    const selectedDriverAssistantDelete = (driverAssistant) => {
        setSelectedDriverAssistant(driverAssistant);
        setShowModalDelete(true)
    }

    const deleteDriverAssistant = () => {
        driverAssistantService.del(selectedDriverAssistant.id).then(() => {
            toast.success("Ajudante deletado com sucesso");
            setShowModalDelete(false);
            loadDriverAssistants();
        }).catch(error => {
            toast.error(error.response.data.message)
        })
    }

    return (
        <div className="w-full">
            <div>
                <form onSubmit={handleSubmitDriverAssistants} className="bg-white rounded-lg shadow-md p-6 mb-8 fade-in">
                    <div className="flex flex-col md:flex-row md:items-center md:justify-between gap-4">
                        <div className="w-full md:w-3/3 flex flex-col sm:flex-row gap-3">
                            <div className="flex-1">
                                <DropDown
                                    id="cadastroBranchId"
                                    label="Buscar por Filial"
                                    optionValue="id"
                                    optionLabel="name"
                                    optionIcon="image"
                                    name="branchId"
                                    placeholder="Todas"
                                    value={formik.values.branchId}
                                    options={branches}
                                    onChange={formik.handleChange}
                                />
                            </div>
                            <div className="flex-1">
                                <label for="search" className="block text-sm font-medium text-gray-700 mb-1">Buscar por Código</label>
                                <div className="relative">
                                    <input
                                        type="searchCode"
                                        id="search"
                                        name="id"
                                        placeholder="Digite o código..."
                                        className="w-full px-5 py-2 pl-10 border-1 border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
                                        value={formik.values.id}
                                        onChange={formik.handleChange}
                                    />
                                    <i className="fas fa-search absolute left-3 top-3 text-gray-400"></i>
                                </div>
                            </div>
                            <div className="flex-1">
                                <label for="search" className="block text-sm font-medium text-gray-700 mb-1">Buscar por Nome</label>
                                <div className="relative">
                                    <input
                                        id="searchName"
                                        type="text"
                                        name="name"
                                        placeholder="Digite o nome..."
                                        className="w-full px-5 py-2 pl-10 border-1 border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
                                        value={formik.values.name}
                                        onChange={formik.handleChange}
                                    />
                                    <i className="fas fa-search absolute left-3 top-3 text-gray-400"></i>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="flex flex-wrap gap-2 mt-3">
                        <div className="flex items-end">
                            <ButtonLoading for="file-upload"
                                type="submit"
                                label="Pesquisar"
                                icon="fas fa-search"
                                color="indigo"
                            />
                        </div>
                        <div className="flex items-end">
                            <ButtonLoading
                                for="file-upload"
                                label="Cadastrar"
                                type="button"
                                color="green"
                                icon="fas fa-save"
                                onClick={() => setShowModalCreate(true)}
                            />
                        </div>
                    </div>
                </form>
                {loading ? (
                    <div className="text-center py-10">
                        <i className="fas fa-spinner fa-spin text-4xl text-indigo-600 mb-4" />
                        <p className="text-gray-600">Carregando ajudantes...</p>
                    </div>
                ) : totalElements === 0 ? (
                    <div className="text-center py-10">
                        <i className="fas fa-inbox text-4xl text-gray-400 mb-4" />
                        <p className="text-gray-600">Nenhum ajudante encontrado</p>
                    </div>
                ) : (
                    <div className="bg-white rounded-lg shadow overflow-hidden fade-in">
                        <div className="overflow-x-auto">
                            <table className="min-w-full divide-y divide-gray-200">
                                <thead className="bg-gray-50">
                                    <tr>
                                        <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Código</th>
                                        <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Nome</th>
                                        <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Filial</th>
                                        <th className="px-6 py-3 text-right text-xs font-medium text-gray-500 uppercase tracking-wider">Ações</th>
                                    </tr>
                                </thead>
                                <tbody className="bg-white divide-y divide-gray-200">
                                    {driverAssistants.map(driverAssistant => (
                                        <tr key={driverAssistant.id}>
                                            <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900">{driverAssistant.id.substring(4)}</td>
                                            <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900">{driverAssistant.name}</td>
                                            <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900">{driverAssistant.branchName}</td>
                                            <td className="px-6 py-4 whitespace-nowrap text-sm text-right">
                                                <button className="text-blue-600 hover:underline text-sm mr-2" onClick={() => selectedDriverAssistantUpdate(driverAssistant)}>Editar</button>
                                                <button className="text-red-600 hover:underline text-sm" onClick={() => selectedDriverAssistantDelete(driverAssistant)}>Excluir</button>
                                            </td>
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                        </div>

                        <div className="px-6 py-4 bg-gray-50 border-t border-gray-200 flex items-center justify-between">
                            <div className="text-sm text-gray-600">
                                Mostrando {page * pageSize + 1} a {Math.min((page + 1) * pageSize, totalElements)} de {totalElements} ajudantes
                            </div>
                            <div className="flex space-x-2">
                                <button onClick={handlePrevPage} disabled={page === 0} className="px-3 py-1 border rounded-md text-sm font-medium text-gray-700 bg-white hover:bg-gray-50 disabled:opacity-50">
                                    Anterior
                                </button>
                                <button onClick={handleNextPage} disabled={(page + 1) * pageSize >= totalElements} className="px-3 py-1 border rounded-md text-sm font-medium text-gray-700 bg-white hover:bg-gray-50 disabled:opacity-50">
                                    Próximo
                                </button>
                            </div>
                        </div>
                    </div>
                )}
            </div >
            {showModalCreate && (
                <div id="import-modal-create" className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
                    <div className="bg-white rounded-lg shadow-lg w-[90%] max-w-4xl p-8 fade-in">
                        <div className="flex justify-between items-center mb-4">
                            <h3 className="text-lg font-medium text-gray-900">Cadastro de Ajudante</h3>
                            <button id="close-modal" className="text-gray-400 hover:text-gray-500" onClick={() => setShowModalCreate(false)}>
                                <i className="fas fa-times"></i>
                            </button>
                        </div>
                        <div className="grid gap-4 mb-4">
                            <DriverAssistantCreate branches={branches} setShowModal={setShowModalCreate} onChange={loadDriverAssistants} />
                        </div>
                    </div>
                </div>
            )}
            {showModalUpdate && (
                <div id="import-modal-create" className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
                    <div className="bg-white rounded-lg shadow-lg w-[90%] max-w-4xl p-8 fade-in">
                        <div className="flex justify-between items-center mb-4">
                            <h3 className="text-lg font-medium text-gray-900">Atualização de Ajudante</h3>
                            <button id="close-modal" className="text-gray-400 hover:text-gray-500" onClick={() => setShowModalUpdate(false)}>
                                <i className="fas fa-times"></i>
                            </button>
                        </div>
                        <div className="grid gap-4 mb-4">
                            <DriverAssistantUpdate driverAssistant={selectedDriverAssistant} branches={branches} setShowModal={setShowModalUpdate} onChange={loadDriverAssistants} />
                        </div>
                    </div>
                </div>
            )}
            {showModalDelete && (
                <div id="import-modal" className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
                    <div className="bg-white rounded-lg shadow-xl p-6 w-full max-w-md fade-in">
                        <div className="flex justify-between items-center mb-4">
                            <h3 className="text-lg font-medium text-gray-900">Confirmar Exclusão</h3>
                            <button id="close-modal" className="text-gray-400 hover:text-gray-500" onClick={() => setShowModalDelete(false)}>
                                <i className="fas fa-times"></i>
                            </button>
                        </div>

                        <p className="text-center text-md text-gray-500 mb-4">Você realmente deseja excluir esse ajudante? </p>

                        <div className="flex justify-end space-x-3">
                            <ButtonLoading id="cancel-import"
                                color="gray"
                                label="Cancelar"
                                onClick={() => setShowModalDelete(false)}
                                disabled={(loading)}

                            >
                                Cancelar
                            </ButtonLoading>
                            <ButtonLoading
                                label="Confirmar"
                                color="blue"
                                id="confirm-import"
                                onClick={deleteDriverAssistant}
                            >
                                Confirmar Exclusão
                            </ButtonLoading>
                        </div>
                    </div>
                </div>
            )}
        </div>
    )
}

export default DriverAssistantList;